export type MunilyNotificationCardType = 'toggle' | 'icon';

export interface MunilyNotificationCardFooter {
  label: string;
  value: string;
}

export const MUNILY_NOTIFICATION_CARD_DEFAULT_TYPE: MunilyNotificationCardType = 'toggle';
